// Stable per-browser identifier so a reporter can list their own previous
// feedback in the widget without exposing the project's full inbox. Created
// lazily on first read. We never send it server-side as an identity — it's
// scoped to the project's public key, so leakage is bounded to that project.

const KEY = "maua-feedback-client-id";

export function getOrCreateClientId(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing && /^[a-z0-9-]{8,}$/.test(existing)) return existing;
    const fresh = (crypto.randomUUID?.() ?? Math.random().toString(36).slice(2)).toLowerCase();
    localStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    // Private mode etc. — fall back to a session-scoped id so list works
    // within this tab, just doesn't survive page reload.
    return (crypto.randomUUID?.() ?? Math.random().toString(36).slice(2)).toLowerCase();
  }
}
